module.exports = __webpack_public_path__ + "static/img/businessInfo_active.b596a787.svg";